import i18n from "../../constants/i18n";
import Et3Image from "../../core/et3-Image";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";

const RotateDevice = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-end"
      withShadow={true}
      width={2000}
      height={1080}
      color={colors.all.transparentGray}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("ALKHATTABA_ADMIN")}
        imageName={"rotate-device"}
        size={1660}
        onClick={() => {}}
        style={{}}
      />
    </ET3Div>
  );
});
export default RotateDevice;
